import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { COUNTRY_TO_LANG, LS_LANGUAGE_KEY, resources, SUPPORTED_LANGUAGES } from '../config';



i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      lookupCookie: 'locale',
      lookupLocalStorage: LS_LANGUAGE_KEY,
      lookupFromPathIndex: 0,
      order: ['path', 'localStorage', 'navigator'],
      cookieOptions: {
        path: '/'
      }
    },
    resources,
    fallbackLng: COUNTRY_TO_LANG.EN,
    supportedLngs: Object.keys(SUPPORTED_LANGUAGES),
    interpolation: {
      escapeValue: false
    }
  });

i18n.on('initialized', () => {
  document.documentElement.lang = i18n.language;
});

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
